import { ColorProps } from '@chakra-ui/react';
import { SnackBar, useFeatureFlag } from '@payflip/ui/v2';
import { useGetAppBannerQuery } from './queries.cms.generated';

type Variant = 'success' | 'warning' | 'alert' | 'info';

const variantBgColors: Record<Variant, ColorProps['color']> = {
  info: 'palette_blue.100',
  success: 'palette_success.50',
  warning: 'palette_warning.50',
  alert: 'palette_alert.100'
};

const variantTextColors: Record<Variant, ColorProps['color']> = {
  info: 'palette_white',
  success: 'palette_white',
  warning: 'palette_white',
  alert: 'palette_white'
};

//TODO EXTRACT THIS INTO THE WEB LIBRARY
export function AppBanner(): JSX.Element | null {
  const { data } = useGetAppBannerQuery();
  const cms = data?.bannerContent?.data?.attributes;
  const variant = cms?.variant ?? 'info';
  const isEnabled = useFeatureFlag('showBanner');
  if (!isEnabled || !cms) {
    return null;
  }
  return (
    <SnackBar
      title={cms?.body ?? ''}
      link={
        cms?.linkSection?.link
          ? {
              label: cms?.linkSection?.label ?? '',
              to: cms?.linkSection?.link ?? ''
            }
          : undefined
      }
      backgroundColor={variantBgColors[variant] ?? 'palette_blue.100'}
      color={variantTextColors[variant] ?? 'palette_white'}
      canBeClosed={cms?.isClosable ?? false}
      withGradient={false}
    />
  );
}
